import axios from "axios";
import { HierarchyNodeVM } from "../model/hierarchy-node-vm.model";
import EditAddUserForm from "../components/my-structure/add-user-form.model";

const baseApiUrl = "api/hierarchy";

export default class HierarchyService {
  public getHierarchyByUserId(id: number): Promise<HierarchyNodeVM> {
    return new Promise<HierarchyNodeVM>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/get-hierarchy-by-user-id/${id}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public addUserBelowManager(user: EditAddUserForm): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/add-user-below-manager`, user)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public editUser(user: EditAddUserForm): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/edit-user`, user)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public moveUser(req): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/move-user`, req)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public deactivateUser(id: EditAddUserForm): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/deactivate-user/${id}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
